import { Badge, Button, Label, Select, TextInput } from "flowbite-react";
import { useContext, useEffect, useRef, useState } from "react";
import { ArrowBack, Upload, UploadCloud } from "../../layouts/icons";
import { Link } from "react-router-dom";
import { WriteUserData } from "../../services/firebaseActions/uploaderActions";
import { FileFormat } from "../../helpers/fileUploader/renameFile";
import { StorageContext } from "./uploadSection";
import {
  C_DIVIDEND_FEED,
  C_GENERAL,
  C_LEGAL_DOCUMENTS,
  C_TRADING_HOURS,
} from "../../constants/types";
import { StatusContext } from "../../context/statusProvider";
import { ResponseContext } from "../../context/responseProvider";
import { UPLOAD } from "../../routes/routes";
import { requiresSubCategory } from "../../helpers/fileUploader/subCategoryConfig";
import { TradingHourTypes } from "../../helpers/fileUploader/objects";
import ConditionalRender from "../../helpers/fileUploader/condtRender";

export const UploadForm = (props) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [category, setCategory] = useState(props.formType);
  const [userId] = useState(localStorage.userEmail);
  const [fileName, setFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [disableBtn, setDiableBtn] = useState(false);
  const [error, setError] = useState("");
  const { subCategory } = useContext(StorageContext);
  const { handleApi } = useContext(StatusContext);
  const { getResponse, setResponse } = useContext(ResponseContext);
  const [tradingHrsSite, setTradingHrsSite] = useState(
    TradingHourTypes()[0].value,
  );

  const formRef = useRef(0);

  const handleFileInput = (e) => {
    if (e.target.files[0] != null) {
      if (category !== C_GENERAL) {
        const formater = FileFormat(
          e.target.files[0],
          category,
          tradingHrsSite,
        );
        setSelectedFile(formater);
        setFileName(formater.name);
      } else {
        setSelectedFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    //write data to rtdb
    WriteUserData(
      fileName,
      category,
      userId,
      setIsLoading,
      setResponse,
      formRef,
      subCategory,
      handleApi,
      selectedFile,
      setFileName,
      setSelectedFile,
      setError,
    );
  };

  useEffect(() => {
    setCategory(props.formType);
  }, [category, props.formType]);

  useEffect(() => {
    const isFormIncomplete =
      !selectedFile ||
      !userId ||
      !category ||
      (requiresSubCategory(category) && !subCategory);

    setDiableBtn(isFormIncomplete);
  }, [selectedFile, userId, category, subCategory]);

  return (
    <div className="st-2 w-full sm:w-2/3">
      <div className="flex h-full flex-col justify-center gap-4 p-6 pl-2">
        <div className="w-max">
          {getResponse("write_rtdb")?.status === true ? (
            <Badge color="success">Updated successfully!</Badge>
          ) : getResponse("write_rtdb")?.status === false ? (
            <Badge color="failure">Upload failed..</Badge>
          ) : (
            ""
          )}
        </div>
        <div className="mb-2 block">
          <Label value="File Name:" />
          <p className="text-sm font-normal text-gray-500 dark:text-gray-400">
            {category === C_LEGAL_DOCUMENTS && subCategory !== "" && (
              <>
                Uploading to <strong>{subCategory}</strong> -
              </>
            )}{" "}
            {fileName !== "" ? <strong>{fileName}</strong> : "Choose file"}
          </p>
          <p className="mt-1 text-xs text-amber-600">
            Existing files with the same name will be replaced.
          </p>
        </div>
        <ConditionalRender condition={[C_TRADING_HOURS]}>
          <div className="mb-2 block">
            <Select
              id="tradingHrSite"
              required={true}
              defaultValue={TradingHourTypes()[0].value}
              onChange={(e) => setTradingHrsSite(e.target.value)}
            >
              <option value="" disabled>
                Choose here
              </option>
              {TradingHourTypes().map((item, index) => {
                return (
                  <option key={index} value={item.value}>
                    {item.site}
                  </option>
                );
              })}
            </Select>
          </div>
        </ConditionalRender>
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          className="flex flex-col gap-4 "
          ref={formRef}
        >
          <div>
            <div className="mb-2 block">
              <Label htmlFor="uploaderId" value="Uploaded by" />
            </div>
            <TextInput
              id="email1"
              type="email"
              placeholder="name@gomarkets.com"
              value={localStorage.getItem("userEmail")}
              required={true}
              // helperText="Email address you used to sign in"
              pattern={localStorage.getItem("userEmail")}
              disabled
            />
          </div>

          <div id="fileUpload" className="mt-10">
            <span className="text-red-500 text-sm">
              {error !== "" && error}
            </span>
            <div className="flex justify-center items-center w-full">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col justify-center items-center w-full h-64 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col justify-center items-center pt-5 pb-6">
                  <UploadCloud />
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {category === C_DIVIDEND_FEED ||
                    category === C_TRADING_HOURS
                      ? "Accepted format: csv"
                      : category === C_GENERAL
                        ? "Accepted formats: pdf, doc, docx, csv, txt, png, jpg"
                        : "Accepted formats: pdf, doc, docx, csv, txt, png, jpg"}
                  </p>
                  {fileName !== "" && (
                    <div className="inline-block w-[263.98px] mt-2 font-bold text-xs">
                      <span className="truncate block text-xs text-primary dark:text-gray-400">
                        <span className="text-gray-500 dark:text-gray-400">
                          Uploading:
                        </span>{" "}
                        {fileName}
                      </span>
                    </div>
                  )}
                </div>
                <input
                  id="dropzone-file"
                  type="file"
                  className="opacity-0 absolute  w-[263.99px] h-[256px]"
                  onChange={handleFileInput}
                  accept={
                    category === C_DIVIDEND_FEED || category === C_TRADING_HOURS
                      ? ".csv"
                      : ".pdf,.doc,.docx,.csv,.txt,.png,.jpg,.jpeg"
                  }
                  required={true}
                />
              </label>
            </div>
          </div>
          <div className="flex mt-8 theme-variant items-center justify-between ">
            <Link
              to={`/${UPLOAD}`}
              className="inline-flex items-center text-center"
            >
              <ArrowBack /> Return
            </Link>

            {isLoading ? (
              <Upload />
            ) : (
              <Button type="submit" disabled={disableBtn}>
                Upload
              </Button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
